<template>
  <div data-page='3' class="portfolio page">
     <section class="hero-content fill-height">
       <div class="page-media">
         <IgCards></IgCards>
        </div>
    </section>
  </div>
</template>

<script>
  import UiModal from '@/components/UiModal.vue'
  import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
  import IgCards from '@/components/IgCards'

  export default {
    name: 'GalleryPage',

    components: {
      UiModal,
      UiBaseIcon,
      IgCards,
    },

    data () {
      return {
        title: null,
        headline: null,
        bgTxt: 'KALE',
        imgLinks:'/static/media/Southwind/southwind-1.jpg',
        isShowModal: {
          a: false,
          b: false
        }
      }
    },

    methods: {
      submitModalHanlder() {
        this.isShowModal = false;
      },
    }
  }
</script>
<style lang="scss" scoped>
  .page-body{
    top: 0;
  }

  .modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10vh;
  }

  .project-img {
    max-height: 80vh;
    margin: 0 auto;
    display: block;
  }

  .button-prev,
  .button-next {
    cursor: pointer;
    height: 40px;
    margin-top: -22px;
    position: absolute;
    top: 50%;
    transform: rotate(45deg);
    width: 40px;
    z-index: 10;
  }

  .button-next {
    right: 20px;
    left: auto;
    border-right: 5px solid $prime-color;
    border-top: 5px solid $prime-color;
  }

  .button-prev {
    left: 20px;
    right: auto;
    border-left: 5px solid $prime-color;
    border-bottom: 5px solid $prime-color;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Gallery.vue